import deviceSettingsSlice from '.';

export const { setDeviceVariant, unsetEndedExperiments } = deviceSettingsSlice.actions;
